import { Field } from "@sitecore-jss/sitecore-jss-react";

export default function useFieldData(fieldData: Record<string, Field<string> | object>, name: string) {
  const heading = fieldData["Heading" + name] ? fieldData["Heading" + name] : { value: "" };
  const placeholder = fieldData["Placeholder" + name] ? fieldData["Placeholder" + name] : { value: "" };
  const prefix = fieldData["Prefix" + name] ? fieldData["Prefix" + name] : { value: "" };
  const suffix = fieldData["Suffix" + name] ? fieldData["Suffix" + name] : { value: "" };
  const info = fieldData["Info" + name] ? fieldData["Info" + name] : { value: "" };
  const tooltip = fieldData["Tooltip" + name] ? fieldData["Tooltip" + name] : { value: "" };

  return { heading, placeholder, prefix, suffix, info, tooltip } as Record<string, Field<string>>;
}
